import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { catLabel, catColor } from "@/lib/lore";

export const DismissedSuggestions = ({ uid }) => {
  const qc = useQueryClient();
  const { data = [], isLoading } = useQuery({ queryKey: ["dismissed-suggestions", uid], queryFn: () => api.get(`/universes/${uid}/dismissed-suggestions`).then((r) => r.data) });
  const restore = async (d) => {
    try {
      await api.delete(`/dismissed-suggestions/${d.id}`);
      qc.setQueryData(["dismissed-suggestions", uid], (all) => all.filter((x) => x.id !== d.id));
      toast.success(`“${d.name}” can be suggested again in the next lore review`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (isLoading) return null;
  if (!data.length) return <p className="text-sm text-[#A8A090]" data-testid="dismissed-empty">Nothing dismissed. When you dismiss a “mentioned without an entry” suggestion, it shows up here.</p>;
  return (
    <ul className="max-h-80 space-y-1.5 overflow-y-auto pr-1" data-testid="dismissed-list">
      {data.map((d) => (
        <li key={d.id} className="flex items-center gap-3 rounded-md border border-[#2D3442] bg-[#0F131A] px-3 py-2" data-testid={`dismissed-item-${d.id}`}>
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm text-[#F3EBDD]">{d.name}{d.category && <span className="ml-2 text-[10px] uppercase tracking-[0.14em]" style={{ color: catColor(d.category) }}>{catLabel(d.category)}</span>}</div>
            {d.summary && <div className="truncate text-xs text-[#A8A090]">{d.summary}</div>}
          </div>
          <Button size="sm" variant="ghost" onClick={() => restore(d)} data-testid={`dismissed-restore-${d.id}`}><RotateCcw className="mr-1 h-3.5 w-3.5" />Restore</Button>
        </li>
      ))}
    </ul>
  );
};
